import PrefsService from "../services/PrefsService"
export default function () {
    let currentPreferencesVersion = PrefsService.get('prefVersion', 0)

    // Find the js file in the migration dir
    let files = require.context('./', false, /\d+\.js$/)

    // Assume that the file name is the version number
    let migrations = Object.fromEntries(files.keys().map(x => [x.match(/(\d+)\.js$/)[1], files(x)]))

    console.debug('Starting migration for prefs version ', currentPreferencesVersion)

    // Sort the migration steps
    let steps = Object.keys(migrations).map(x => Number(x))
    steps.sort((a, b) => a - b)

    for (let m of steps) {
        try {
            if (currentPreferencesVersion < m) {
                console.debug('Applying migration ' + m)
                // Run migration
                migrations[m].default()

                currentPreferencesVersion = m
            } else {
                console.debug('Migration ' + m + ' not needed')
            }
        } catch (ex) {
            console.error('Failed to apply migration step ' + m, ex)
            return false
        }
    }

    PrefsService.put('prefVersion', currentPreferencesVersion)
    console.debug('Migration finished')
    return true
}
